// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Unlock(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Unlock" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 22V10H15V8C15 6.34315 13.6569 5 12 5C11.1115 5 10.3132 5.38625 9.76389 6H6.34141C7.16508 3.66962 9.38756 2 12 2C15.3137 2 18 4.68629 18 8V10H20V22H4ZM14 16C14 17.1046 13.1046 18 12 18C10.8954 18 10 17.1046 10 16C10 14.8954 10.8954 14 12 14C13.1046 14 14 14.8954 14 16Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Unlock.js.map